// extracted by mini-css-extract-plugin
export var link = "_ps-0";